const translations = {
    button: 'Save',
    title: 'User Details'
};

export default translations;
